import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function MenuIcon({ active, item }) {
    return (
        <div className="block w-6 h-6">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={classNames(
                    'dark:text-blue-gray-150 dark:group-hover:text-blue-gray-150',
                    {
                        'text-blue-600': active,
                        'text-blue-gray-300 group-hover:text-blue-gray-500':
                            !active,
                    },
                )}
            >
                {item.iconPath}
            </svg>
        </div>
    );
}

MenuIcon.propTypes = {
    active: PropTypes.bool.isRequired,
    item: PropTypes.shape({
        iconPath: PropTypes.node.isRequired,
    }).isRequired,
};
